import C from '../actions/constants'

export const atomicMass = (state = {}, action) => {
    switch (action.type) {
        case C.SET_ATOMIC_MASS_VALUES:
            return { ...state, ...action.payload }
        default:
            return state
    }
}